enum NavDevices {
  DEVICES_LIST = 'DEVICES_LIST',
  DEVICES_GROUP = 'DEVICES_GROUP'
}

export default NavDevices;
